export const featureRMDF = (): boolean => process.env.REACT_APP_FEATURE_RMDF === 'true'
export const featureRMDFMonthly = (): boolean => process.env.REACT_APP_FEATURE_RMDF_MONTHLY === 'true'
